export default "__VITE_ASSET__Rx10oddO__"